@let gridData = $gridData();
@let T = gridData.data;
<unity-grid-shared
  *unityAuthorize="'Role:List'"
  gridTitle="Roles"
  [gridData]="gridData"
  [gridError]="$gridError()"
  [gridLoading]="$gridLoading()"
  (dataQueryEvent)="onDataQuery($event)">
  <kendo-grid-column field="name" title="Name">
    <ng-template let-role kendoGridCellTemplate [unityTyped]="T">
      <unity-link-gridcell-shared [displayText]="role.name" [link]="['/business-partner', role.agency.id, 'role', role.id]" />
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="description" title="Description" />
  <kendo-grid-column field="parent_role.name" title="Parent Role" />
</unity-grid-shared>
